const LOGIN_FLAG_KEY = "qywx_login_flag"
const LOGIN_USER_ID_KEY = "qywx_login_user_id"

function safeStorage() {
  try {
    return window.localStorage
  } catch (e) {
    return null
  }
}

export function getLoginUserId() {
  const storage = safeStorage()
  return storage ? storage.getItem(LOGIN_USER_ID_KEY) || "" : ""
}

export function isLoggedIn() {
  const storage = safeStorage()
  if (!storage) return false
  return storage.getItem(LOGIN_FLAG_KEY) === "1" && !!storage.getItem(LOGIN_USER_ID_KEY)
}

export function saveLoginUserId(userId) {
  const storage = safeStorage()
  if (!storage) return
  storage.setItem(LOGIN_FLAG_KEY, "1")
  if (userId) storage.setItem(LOGIN_USER_ID_KEY, String(userId))
}

export function clearLoginResult() {
  const storage = safeStorage()
  if (!storage) return
  storage.removeItem(LOGIN_FLAG_KEY)
  storage.removeItem(LOGIN_USER_ID_KEY)
}

